import { AfterViewChecked, Component, ElementRef, OnDestroy, OnInit, Renderer2, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { debounceTime, Observable, Subscription } from 'rxjs';
import { BENEFITS_KEY } from 'src/app/components/Price-subscritions/priceplanService';
import { ApiService } from 'src/app/services/api.service';
import { ExcelService } from 'src/app/services/excelService';
import { UtilService } from 'src/app/services/util.service';
import Swal from 'sweetalert2';
import { CustomerService, TEXT_FIELDS } from '../customer-service.service';

import { BsModalService } from 'ngx-bootstrap/modal';
import { AppSettings } from 'src/app/services/AppSettings';
import { FormValidation, SWAL_WITH_BUTTONS } from 'src/app/services/FormValidation';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { MatMenuModule } from '@angular/material/menu';
import { PlanCardComponent } from '../plan-card/plan-card.component';
import { CustomerSearchComponent } from '../customer-search/customer-search.component';
import { UpgradeMessageComponent } from 'src/app/upgrade-message/upgrade-message.component';
import { CommonModalComponent } from '../common-modal/common-modal.component';
import { MtaFilterPipe } from 'src/app/pipe/name-filter.pipe';
import { underscoreRemovePipe } from 'src/app/pipe/UnderscopeRemove';
import { TitleCasePipe, DatePipe } from '@angular/common';
import { TimezoneDatePipe } from 'src/app/timezone-date.pipe';
import { NodataFoundComponent } from '../../../../widget/nodata-found/nodata-found.component';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';


@Component({
  selector: 'app-customer-contact',
  standalone: true,
  imports: [CommonModule, FormsModule, NgxDatatableModule, MatMenuModule,
PlanCardComponent, CustomerSearchComponent, UpgradeMessageComponent, CommonModalComponent, MtaFilterPipe, underscoreRemovePipe, TitleCasePipe, TimezoneDatePipe, DatePipe, NodataFoundComponent,
    NG_ICON_DIRECTIVES,
  ],
  templateUrl: './customer-contact.component.html',
  styleUrls: ['./customer-contact.component.scss', '../../../../../styles/admin/style.scss', '../../../../../styles/admin/app.scss']
})
export class CustomerContactComponent extends FormValidation implements OnInit, OnDestroy, AfterViewChecked {
  businessEmail: any;
  businessId: any;
  textFields: Array<Partial<TEXT_FIELDS>>;
  contactData: any;
  PLANMAX: number = 0;
  AVAILABLE: number = 0;
  ALLOCATED: number = 0;
  MemberShipType: any
  refreshSubcription: Subscription;
  filterSubscription: Subscription;
  searchSubscription: Subscription;
  allocationCards: { name: string; value: number }[] = [];
  isBusinessOrEnterpriseUser: boolean = false;

  role: any
  listToShow$: any;
  params: any;
  constructor(
    private router: Router,
    private _activated_route: ActivatedRoute,
    private _api_service: ApiService,
    public util: UtilService,
    private excel: ExcelService,
    private customerService: CustomerService,
    private modalService: BsModalService,
    private renderer: Renderer2, private el: ElementRef,
  ) {
    super();
    this._activated_route.parent.data.subscribe(res => {
      console.log("customer works", res);

      this.businessId = res.data.id
      this.MemberShipType = res.data.plan;
      this.role = res.data.role
      this.businessName = res.data.businessName;
      this.businessEmail = res.data.businessEmail
    });
    // Default values: Use zeros when no business/plan, or specific defaults for Free
    const defaultValues = this.MemberShipType === "Free"
      ? [2000, 0, 2000]
      : [0, 0, 0];
    const cardNames = ["Plan Max", "Allocated", "Available"];
    this.allocationCards = cardNames.map((name, index) => ({
      name,
      value: defaultValues[index],
    }));

    this.refreshSubcription = this.customerService.getRefreshKey().subscribe(ress => {
      if (ress === "contacts") {
        // this.fetchData(this.businessId);
        this.userPayload.page = 0;
        this.nextPage({ offset: 0 });
      }
    });

    this.filterSubscription = this.customerService.getFilterValue().subscribe(res => {
      if (res.key === 'contacts') {
        console.log('the customer search component : ', res);
        this.userPayload.page = 0;
        const { key, ...rest } = res.value;
        // if (rest.businessNetworks != null) {
        //   rest.businessNetworks = rest.businessNetworks
        // }
        if (rest.userType != null) {
          rest.userType = [rest.userType]
        }else {
          this.userPayload.userType = null;
        }
        this.userPayload.searchContent = null;
        this.userPayload.organisationType = rest.organisationType ?? null;
        this.userPayload.businessNetworks = rest.businessNetworks ?? null;
        this.userPayload = { ...this.userPayload, ...rest }
        this.customerService.setFilterPayload(this.userPayload);
        this.fetchData(this.businessId);
      }
    });


    this.searchSubscription = this.customerService.getSearchValue().pipe(
      debounceTime(1000),
    ).subscribe(response => {
      if (response.key === "contacts") {
        this.userPayload.page = 0;
        this.userPayload.searchContent = response.value;
        this.fetchData(this.businessId);
      }
    });

    this.textFields = [
      { label: "User", key: "fullName", value: null, type: "STRING" },
      { label: "Email ID", key: "email", value: null, type: "STRING" },
      { label: "Role", key: "userType", value: null, type: "STRING" },
      { label: "Company", key: "organisation", value: null, type: "STRING" },
      { label: "Company Type", key: "clientType", value: null, type: "STRING" },
      { label: "Contact Type", key: "contactType", value: null, type: "STRING" },
      { label: "Partner since", key: "startDate", value: null, type: "DATE" },
      { label: "Last Active", key: "lastLoggedOn", value: null, type: "DATE" },
      { label: "Network", key: "networkName", value: null, type: "LIST" },
      { label: "Status", key: "connectionStatus", value: null, type: "STRING" },


    ]

  }


  public listToShow: Array<any> = []

  ngOnInit(): void {
    if (this.businessId) {
      this.fetchData(this.businessId);
    }
    this.checkUserPlan(this.MemberShipType);
  }

  checkUserPlan(memberShipType: string) {
    this.isBusinessOrEnterpriseUser = this.customerService.isBusinessOrEnterprise(memberShipType);
  }
  @ViewChild('sortTable') table: any;
  onSort(event) {
    const currentPage = this.userPayload.page;
    this.table.offset = currentPage;
  }

  checkrolebased() {
    return this.MemberShipType !== "Free" &&
      this.role !== "EMPLOYEE" && this.role !== "ADMIN";
  }
  scrollSynced = false;
  bodyScrollUnlistener: () => void;
  resizeUnlistener: () => void;

  ngAfterViewChecked() {
    const dataTableBody = this.el.nativeElement.querySelector('.datatable-body');
    const dataTableHeader = this.el.nativeElement.querySelector('.datatable-header');

    if (!this.isFirefox()) {
      return;
    }

    if (dataTableBody && dataTableHeader && !this.scrollSynced) {

      if (this.bodyScrollUnlistener) {
        this.bodyScrollUnlistener();
      }
      if (this.resizeUnlistener) {
        this.resizeUnlistener();
      }


      this.bodyScrollUnlistener = this.renderer.listen(dataTableBody, 'scroll', this.throttle(() => {
        dataTableHeader.scrollLeft = dataTableBody.scrollLeft;
      }, 10));


      this.resizeUnlistener = this.renderer.listen(window, 'resize', () => {
        dataTableHeader.scrollLeft = dataTableBody.scrollLeft;
      });

      this.scrollSynced = true;
    }
  }


  isFirefox(): boolean {
    return navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
  }


  throttle(fn: Function, wait: number) {
    let time = Date.now();
    return function () {
      if ((time + wait - Date.now()) < 0) {
        fn();
        time = Date.now();
      }
    };
  }

  getNetworkDisplayName(networkName: string): { name: string, count: number } {
    if (!networkName) {
      return {
        name: '',  // or a default name
        count: 0
      };
    }
    const networks = networkName.split(',');
    return {
      name: networks[0],
      count: networks.length - 1
    };
  }


  getTooltipText(networkName: string): string {
    if (!networkName) {
      return ''; // or you can return a default value
    }
    return networkName.split(',').map(name => name.trim()).join('\n');
  }

  onMenuOpened() {
    setTimeout(() => {
      const menuPanel = document.querySelector('.mat-mdc-menu-panel');
      if (menuPanel) {
        this.renderer.setStyle(menuPanel, 'min-width', 'auto');
        this.renderer.setStyle(menuPanel, 'width', 'auto');
        this.renderer.setStyle(menuPanel, 'max-width', 'none');
      }
      const menuItems = document.querySelectorAll('.mat-mdc-menu-item');
      menuItems.forEach(item => {
        this.renderer.setStyle(item, 'min-width', 'auto');
        this.renderer.setStyle(item, 'width', 'auto');
        this.renderer.setStyle(item, 'white-space', 'nowrap');
      });
    }, 0);
  }

  removeUserContact(value: any) {



    SWAL_WITH_BUTTONS.fire({
      icon: "warning",
      showConfirmButton: true,
      showCancelButton: true,
      reverseButtons: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      title: "Remove Contact",
      text: `Are you sure you want to remove ${value.fullName} ?`
    }).then(res => {


      if (res.isConfirmed) {

        value.expanded = false;
        this.util.startLoader();
        this._api_service.delete(`business/removeBusinessUsersContact/${this.businessId}/${value.userId}`).subscribe(
          (res) => {
            this.util.stopLoader();
            if (res.code === '00000') {
              Swal.fire({
                icon: 'success',
                title: 'Contact removed successfully',
                showConfirmButton: false,
                timer: 2000,
              }).then(() => {
                this.ngOnInit();
              });
            }
          },
          (error) => {
            this.util.stopLoader();
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: 'Something went wrong. Please try again later.',
              showConfirmButton: false,
              timer: 4000,
            });
          }
        );

      }

    })



  }

  ngOnDestroy(): void {

    if (this.refreshSubcription) {
      this.refreshSubcription.unsubscribe();
    }

    if (this.filterSubscription) {
      this.filterSubscription.unsubscribe();
    }

    if (this.searchSubscription) {
      this.searchSubscription.unsubscribe();
    }

    if (this.bodyScrollUnlistener) {
      this.bodyScrollUnlistener();
    }

    if (this.resizeUnlistener) {
      this.resizeUnlistener();
    }
  }

  businessName: string;

  userPayload: any = {
    limit: 10,
    page: 0,
    type: 'LISTING'
  }

  nextPage(data: any) {
    this.userPayload.page = data.offset;
    if (this.userPayload.page == 0) {
      this.userPayload.page = 0;
    }
    this.util.startLoader();
    this.getCustomerUsersList(this.userPayload).subscribe({
      next: (res) => this.handleApiResponse(res),
      error: (error) => this.handleApiError(error)
    });
  }

  public selected = [];
  onSelect({ selected }) {
    this.selected.splice(0, this.selected.length);
    this.selected.push(...selected);
  }



  getCustomerUsersList(userPayload: Object): Observable<any> {
    return this._api_service.create('business/findUserContactsOfBusiness', userPayload);
  }
  handleInvite(value: any, action: 'CANCEL') {
    value.expanded = false;

    // Define contact status based on action
    let status: string;
    let successMessage: string;

    switch (action) {

      case 'CANCEL':
        status = "CANCELLED";
        successMessage = "Contact request cancelled";
        break;
      default:
        status = "";
        successMessage = "";
    }

    // Prepare data for API call
    const data = {
      userId: value.userId,
      businessId: this.businessId,
      status: status,
    };

    this.util.startLoader();
    this._api_service.updatePut("business/updateBusinessUsersContact", data).subscribe(
      (res) => {
        this.util.stopLoader();
        if (res.code == "00000") {
          Swal.fire({
            icon: "success",
            title: successMessage,
            showConfirmButton: false,
            timer: 2000,
          }).then(() => {
            this.updateRowStatus(value, status);
            this.ngOnInit();
          });
        }
      },
      (error) => {
        this.util.stopLoader();
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Something went wrong. Please try again later.",
          showConfirmButton: false,
          timer: 4000,
        });
      }
    );
  }
  updateRowStatus(updatedRow: any, status: string) {
    this.listToShow = this.listToShow.map(row => {
      if (row.businessNetworkId === updatedRow.businessNetworkId) {
        row.connectionStatus = status;
      }
      return row;
    });
  }

  actualContacts: any;
  availableContacts: any;
  selectedItem: string = 'contacts';
  handleApiResponse(res: any) {
    this.util.stopLoader();
    if (res && res.code === AppSettings.SUCESS_CODE) {
      this.listToShow = res.data.businessContactList;
      this.listToShow.forEach(element => {
        element.fullName = element.firstName + " " + element.lastName;
        element.userType = element.userType.replaceAll("_", " ");

      });

      this.userPayload.total = (res.data && res.data.total) ? res.data.total : 0;
      let plan = res.data.businessPlanUsage;
      if (plan) {

        let found = (plan.benefitsUsages && plan.benefitsUsages.
          find(x => (x.benefitKey as BENEFITS_KEY) === 'INCLUDED_CONVERSATIONS'));
        let membershipType = res.data.businessPlanUsage.membershipType;
        if (found) {
          this.PLANMAX = found.actual == 99999999 ? 'Unlimited' : found.actual;
          this.AVAILABLE = found.actual == 99999999 ? 'Unlimited' : found.available;
          this.ALLOCATED = found.utilized;
          this.allocationCards = [
            { name: "Plan Max", value: this.PLANMAX },
            { name: "Allocated", value: this.ALLOCATED },
            { name: "Available", value: this.AVAILABLE },
          ];
        }
        if (found && membershipType) {
          let plandetails = {
            actual: found.actual,
            available: found.available,
            promotional: found.promotional,
            utilized: found.utilized,
            membershipType: membershipType
          };
        }
      }
      this.excel.setCount(res.data?.total);
      this.customerService.setUserData(this.listToShow);
    }
  }

  handleApiError(error: any) {
    this.util.stopLoader();
    console.error('Subscribe Error:', error);
    Swal.fire({
      icon: "error",
      title: "Error",
      text: "An error occurred while fetching data. Please try again later.",
    });
  }

  fetchData(businessId: string) {
    this.userPayload.businessId = businessId;
    this.util.startLoader();
    this.getCustomerUsersList(this.userPayload).subscribe({
      next: (res) => this.handleApiResponse(res),
      error: (error) => this.handleApiError(error)
    });
  }

  showModal: boolean = false;


  openViewmodal(datas: any) {
    if (datas) {
      this.textFields.forEach(vv => {
        let value = this.getNestedValue(datas, vv.key);

        if (value === undefined || value === null) {
          value = "N/A";
        }

        if (vv.label === "Allocated" || vv.label === 'Available') {
          vv.value = this.curryObject(datas, 'benefitsUsageAndBalance')(vv.label === "Allocated" ? "actual" : "available");
          return;
        }

        if (vv.key === "userType") {
          vv.value = datas[vv.key] ? this.util.userAlias(datas[vv.key]) : "N/A";
          return;
        }

        const statusMapping = {
          'REQUEST_SENT': 'Requested',
          'CONNECTED': 'Connected'
        };

        if (vv.key === 'connectionStatus') {
          vv.value = statusMapping[datas[vv.key]] || value;
        } else {
          vv.value = value;
        }
      });
    }

    if (this.textFields) {
      this.openView("Member Details", this.textFields, this.modalService, this.util);
    }
  }
  getNestedValue(data: any, key: string): any {
    return key.split('.').reduce((acc, part) => {
      if (acc === undefined || acc === null) {
        return undefined;
      }
      if (part.includes('[') && part.includes(']')) {
        const [arrayKey, index] = part.split(/[\[\]]/).filter(Boolean);
        return acc[arrayKey] && acc[arrayKey][+index];
      }
      return acc[part];
    }, data);
  }

  openEditModal(row) {
    row.phoneNo = row.phoneNo === null ? 'N/A' : row.phoneNo;
    this.contactData = row;
    this.showModal = true;
  }


  nodatafound() {

    // this.listToShow$.next([...[
    //   {
    //     dummyData: true,
    //     businessNetworkName: 'No data to display',
    //   }
    // ]]);
    // this.params.total = 0;

  }


  handleInvalidSession() {
    Swal.fire({
      icon: "info",
      title: "Invalid session",
      text: "Sorry, your session has expired. We are routing you to login page.",
      showConfirmButton: false,
      timer: 5000,
    }).then(() => {
      localStorage.clear();
      this.router.navigate(['/auth/login']);
      this.util.stopLoader();
      Swal.close();
    });
  }



  closeModal(data) {
    this.showModal = false;

    if (data.content === "SUCESS") {
      this.fetchData(this.businessId);
    }
  }


}
